import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { INoteCreationDTO, INoteDTO } from '@app/infrastructure/models/note';
import { IUserDTO } from '@app/infrastructure/models/user';
import { Subscription } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  tap,
} from 'rxjs/operators';

@Component({
  selector: 'app-edit-notes-presentation',
  templateUrl: './notes-edit.component.html',
  styleUrls: ['./notes-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesEditPresentationComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() note: INoteDTO;
  @Input() currentUser: IUserDTO;
  @Input() editable = false;

  @Output() exit = new EventEmitter<void>();
  @Output() emitDeleteNote = new EventEmitter<number>();
  @Output() save = new EventEmitter<Omit<INoteCreationDTO, 'dayBlockId'>>();
  @Output() emitAutoSaveNote = new EventEmitter<
    Omit<INoteCreationDTO, 'dayBlockId'>
  >();

  date = new Date();

  noteForm = new UntypedFormGroup({
    message: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('thing', [Validators.required]),
    studentId: new UntypedFormControl(null, [Validators.required]),
  });

  sendButtonEnable: boolean = true;

  private subscriptions: Subscription[] = [];

  constructor() {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngOnInit(): void {
    const messageChange = this.noteForm
      .get('message')
      .valueChanges.pipe(
        tap(() => {
          this.sendButtonEnable = this.noteForm.get('message').value.length > 0;
        }),
        filter(() => this.noteForm.valid),
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe(() => this.emitAutoSaveNote.emit(this.noteForm.value));
    this.subscriptions.push(messageChange);
    this.noteForm.patchValue({
      studentId: this.currentUser.student?.id,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { note } = changes;

    if (note) {
      const noteValue = changes.note.currentValue;
      if (noteValue) {
        this.noteForm.patchValue({
          ...noteValue,
        });
        this.date = new Date(noteValue.createdAt);
      }
    }
  }

  getDate(dateStr: string): string {
    return Date.parse(dateStr).toString();
  }

  submitNote(): void {
    this.save.emit(this.noteForm.value);
  }

  deleteNote(): void {
    this.emitDeleteNote.emit(this.note.id);
  }

  close(): void {
    this.exit.emit();
  }
}
